import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { Svg } from 'ui'
import { heroSectionData } from 'components/FreeDns/sections/Hero/heroSectionData'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export default function FreeDNSFeaturesCards(): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: ['column', 'row'],
        justifyContent: 'center',
        maxWidth: '151.2rem',
        width: ['100%', '100%'],
        gap: '2.4rem',
        px: ['1.2rem', '2.4rem', '12rem'],
        mt: ['4.8rem', 0],
        mb: ['6.4rem', '2rem'],
        zIndex: 'zIndex5',
      }}
    >
      {heroSectionData?.map(item => (
        <Flex
          key={item.key}
          sx={{
            width: '100%',
            flexDirection: ['row', 'column', 'row'],
            flexShrink: 1,
            border: '1px solid',
            borderColor: 'wakaiwaGrey50',
            borderRadius: '1.2rem',
            p: ['2.4rem', '2.4rem', '4rem'],
            textAlign: 'left',
            gap: '2.4rem',
            minWidth: ['none', 'none', '31.5rem'],
            position: 'relative',
            overflow: 'hidden',
            alignItems: 'center',
          }}
        >
          <Svg
            svg={item.icon}
            descriptiveText={`${item.title} feature background icon`}
            sx={{
              position: 'absolute',
              top: '-10rem',
              right: '-10rem',
              height: '26rem',
              width: '26rem',
              opacity: 0.05,
            }}
            fill={item.color}
          />
          <Svg
            svg={item.iconBg}
            descriptiveText={`${item.title} feature icon`}
            sx={{ width: '8rem', height: '8rem' }}
          />
          <Flex>
            <Flex
              sx={{
                flexDirection: 'column',
                gap: '1.6rem',
              }}
            >
              <TextWithBreakpointVariant
                variant={[
                  'size20Weigh600Line138',
                  'size20Weigh600Line138',
                  'size21Weight600Line138',
                ]}
                tabIndex={0}
                as="h2"
                sx={{
                  color: 'aliceBlue',
                }}
              >
                {item.title}
              </TextWithBreakpointVariant>
              <TextWithBreakpointVariant
                variant={['size15Weight400', 'size15Weight400', 'size16Weight400']}
                tabIndex={0}
                sx={{
                  color: 'lightSteelBlue',
                  lineHeight: '140%',
                }}
              >
                {item.text}
              </TextWithBreakpointVariant>
            </Flex>
          </Flex>
        </Flex>
      ))}
    </Flex>
  )
}
